import React from "react";
import { Heading } from "@telia/teddy";

import "./SubscriptionInformation.less";
import { connect } from "react-redux";
import { MaybeEmpty, isEmpty } from "../../../../../../constants/utils";
import { ExistingSubscription, RootState } from "../../../../../../models";
import { getTransferExistingSubscription } from "../../../../checkout/state/selectors/accountSelectors";
import { convertSubscriptionToTableData } from "../../../utils";
import InformationTable from "../InformationTable/InformationTable";

interface StateProps {
    existingSubscription: MaybeEmpty<ExistingSubscription>;
}

interface SubscriptionInformation extends StateProps {
    existingSubscription: MaybeEmpty<ExistingSubscription>;
    heading: string;
    showExistingOwner?: boolean;
    showNewOwner?: boolean;
}

const SubscriptionInformation: React.FC<SubscriptionInformation> = ({
    heading,
    showNewOwner,
    showExistingOwner,
    // Redux (data)
    existingSubscription,
}) => {
    if (isEmpty(existingSubscription)) return <></>;
    const existingSubscriptionTableData = convertSubscriptionToTableData(
        existingSubscription,
        !!showNewOwner,
        !!showExistingOwner,
        false,
    );
    return (
        <div className="subscription-information">
            <Heading mb="100" as="h2" variant="title-100" className="subscription-information__table-heading">
                {heading}
            </Heading>
            <InformationTable data={existingSubscriptionTableData} />
        </div>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    existingSubscription: getTransferExistingSubscription(state),
});

export default connect(mapStateToProps)(SubscriptionInformation);
